module.exports = __webpack_public_path__ + "static/like-a-pro-6bbe6f52cd8feb5f883bada417d64577.jpg";